const DATA_SELECTOR = {
    GROUP_PRODUCTS_BUNDLE: "[data-group-products-bundle]",
    GROUP_NAME: "data-group-name",
    BUNDLE_PRODUCT: "[data-product-bundle]",
    PRODUCT_ATC_BUTTON: "[data-add-to-cart-bundle]",
};

const normaliseBundleTitle = (value) =>
    (value || "").replace(/\s+/g, " ").trim().toLowerCase();

class FormMultiBundles extends HTMLElement {
    constructor() {
        super();
        this.groupBundleProductEls = this.querySelectorAll(DATA_SELECTOR.GROUP_PRODUCTS_BUNDLE);
        this.productATCButton = this.querySelector(DATA_SELECTOR.PRODUCT_ATC_BUTTON);
        this.isDropdown = this.dataset.formLayout === "infinite-bundle-dropdown";
        this.bundleState = [];
        this.editCartItemKey = localStorage.getItem("editCartItemKey");
        if (this.editCartItemKey) {
            localStorage.setItem("editCartItemKey", "");
            this.productATCButton.textContent = "update bundle";
        }
        this.initialize();
    }

    initialize() {
        this.syncProductBundles();
        this.handleButtonATC();
    }

    syncProductBundles = () => {
        const cartItems = window.cartJSON?.items || []
        const currentItem = cartItems.find(item => item.key === this.editCartItemKey);
        const bundleSelection = currentItem?.properties?._bundle_selection?.split(" <> ") || []; // edit cart item

        this.groupBundleProductEls.forEach((groupBundle, index) => {
            const productBundleElements = groupBundle.querySelectorAll(DATA_SELECTOR.BUNDLE_PRODUCT);
            const productIds = Array.from(productBundleElements).map((el) => el.dataset.productBundleId);
            const currentBundleSelection = bundleSelection.length >= index + 1 ? bundleSelection[index] : null;
            const query = this.buildQueryProducts(productIds);
            if (!query) return;

            this.executeGraphQlQuery({ query })
                .then((response) => response.json())
                .then((data) => {
                    if (data.data?.products?.nodes?.length) {
                        const dataProductBundles = data.data.products.nodes;
                        this.bundleState.push(...dataProductBundles);
                        this.bindLayoutProductBundle(
                            dataProductBundles,
                            groupBundle,
                            productBundleElements,
                            currentBundleSelection
                        );
                    }
                })
                .catch((error) => {
                    console.error("GraphQL Query Error:", error);
                });
        });
    };

    bindLayoutProductBundle = (
        dataProductBundles,
        groupBundle,
        productBundleElements,
        currentBundleSelection
    ) => {
        console.log('dataProductBundles', dataProductBundles);
       dataProductBundles.forEach((product) => {
            const productId = product.id.replace( "gid://shopify/Product/","");
            const bundle = Array.from(productBundleElements).find((el) => el.dataset.productBundleId === productId);
            if (!bundle) return;

            const inputEl = bundle.querySelector("[data-bundle-input]");
            if (inputEl) this.onChangeInput(groupBundle, inputEl);

            product.metafields.forEach((metafield) => {
                if (!metafield) return;
                switch (metafield.key) {
                    case "linked_swatch":
                        const swatchBgEl = bundle.querySelector("[data-linked-swatch-background]");
                        if (swatchBgEl) swatchBgEl.style.backgroundColor = metafield.value;
                        break;
                    case "linked_badge":
                        const badgeEl = bundle.querySelector("[data-linked-badge]");
                        if (badgeEl) {
                            const badges = metafield.value.split("_");
                            badgeEl.textContent = badges[0];
                            badgeEl.style.backgroundColor = badges[1]
                        }
                        break;
                    case this.isDropdown ? "infinite_dropdown_variant_title" : "linked_swatch_title":
                        const titleEl = bundle.querySelector("[data-linked-option-title]");
                        if (titleEl) titleEl.textContent = metafield.value?.toLowerCase();
                        break;
                    default:
                        break;
                }
            });
        });

        const dropdown = groupBundle.querySelector("[data-dropdown-bundle]");
        if (dropdown) {
            dropdown.addEventListener("change", (event) =>
                this.onChangeDropdown(groupBundle, event)
            );
        }

        const inputs = groupBundle.querySelectorAll("[data-bundle-input]");
        const options = groupBundle.querySelectorAll("option[data-product-bundle]");

        if (dropdown && options.length) {
            const newValue = currentBundleSelection ? currentBundleSelection : options[0].value;
            dropdown.value = newValue;
            dropdown.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (inputs.length) {
            const input = Array.from(inputs).find((ip) => ip.value === currentBundleSelection) || inputs[0];
            if (input) input?.click();
        }

        groupBundle.classList.remove("hidden");
    };


    handleButtonATC = () => {
        if (!this.productATCButton) return;

        this.updateButtonATC()

        this.productATCButton.addEventListener("click", (event) => {
            this.classList.add("loading");

            const variantId = this.dataset.variantId;
            if (!variantId) return;

            const properties = {};
            const bundleSelectors = [];
            this.groupBundleProductEls.forEach((bundleEl) => {
                const groupName = bundleEl.dataset.groupName;
                const selectedVariant = bundleEl.querySelector("input[data-bundle-input]:checked");
                if (selectedVariant && selectedVariant.value) {
                    properties[groupName] = selectedVariant.value;
                    bundleSelectors.push(selectedVariant.value);
                }
            });

            if (bundleSelectors?.length) {
                properties["_bundle_selection"] = bundleSelectors.join(" <> ");
            }
            const cartItems = window.cartJSON?.items || []
            const currentItem = cartItems.find(item => item.key === this.editCartItemKey);

            if (this.editCartItemKey && currentItem) {
                this.changeCart(properties);
            } else {
                this.addToCart(variantId, properties);
            }
        });
    };

    onChangeInput = (groupBundle, input) => {
        const productId = input.dataset.productId;
        productId && input.addEventListener("click", () => {
            const productBundle = this.bundleState.find((bundle) =>
                bundle.id.includes(productId)
            );

            if (!productBundle) return;
            this.updateProductLayout(groupBundle, productBundle);
            this.updateButtonATC();
        });
    };

    onChangeDropdown = (groupBundle, event) => {
        const input = groupBundle.querySelector("input[data-bundle-input]:checked");
        const targetValue = event.target.value;
        const inventory = event.target.selectedOptions[0].dataset.inventory || "0";
        if (!input) return;
        input.value = targetValue;
        input.dataset.inventory = inventory;

        // Titles and option values disagree on whitespace, so compare loosely.
        const wanted = normaliseBundleTitle(targetValue);
        const productBundle = this.bundleState.find((bundle) =>
            normaliseBundleTitle(bundle.title).includes(wanted)
        );
        this.updateProductLayout(groupBundle, productBundle);
        this.updateButtonATC()
    };

    updateProductLayout = (groupBundle, productBundle) => {
        // Nothing matched: leave the layout as rendered rather than throwing,
        // which would also skip the link and title below.
        if (!productBundle) return;

        //image
        const imageEl = groupBundle.querySelector("[data-product-image]");
        if (imageEl && productBundle.featuredImage) {
            imageEl.src = productBundle.featuredImage.src;
            imageEl.alt = productBundle.title;
        }

        //link
        const linkEl = groupBundle.querySelector("[data-product-link]");
        if (linkEl) {
            linkEl.href = `/products/${productBundle.handle}`;
        }

        const metafields = productBundle.metafields;
        if (!metafields) return;

        const infiniteTitleMetafield = metafields.find((mf) => mf?.key === "infinite_dropdown_variant_title");
        const swatchTitleMetafield = metafields.find((mf) => mf?.key === "linked_swatch_title");
        const titleEl = groupBundle.querySelector("[data-linked-title]");
        const metafieldValue = infiniteTitleMetafield ? infiniteTitleMetafield.value : (swatchTitleMetafield ? swatchTitleMetafield.value : null);
          
        if (metafieldValue && titleEl) {
            titleEl.textContent = metafieldValue;
        }
    };

    updateButtonATC = () => {
        const bundleInputs = this.querySelectorAll("[data-bundle-input]:checked");
        let allInStock = true;
        bundleInputs.forEach((input) => {
            const inventory = parseInt(input.dataset.inventory || "0", 10);
            if (inventory < 1) {
                this.productATCButton.disabled = true;
                this.productATCButton.textContent = "Sold Out";
                allInStock = false;
                return;
            }
        });

        if (allInStock) {
            this.productATCButton.disabled = false;
            this.productATCButton.textContent = 'add to cart'
        }
    }

    addToCart = (variantId, properties) => {
        const formData = {
            items: [
                {
                    id: variantId,
                    quantity: 1,
                    properties: properties,
                },
            ],
        };

        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }).finally(() => {
            // slide cart edits - start
            if (window.SLIDECART && typeof window.SLIDECART_UPDATE === 'function') {
            window.SLIDECART_OPEN();
            window.SLIDECART_UPDATE();
            } else {
            window.cart.getCart();
            }
            // slide cart edits - end
            this.classList.remove("loading");
        });
    };

    changeCart = (properties) => {
        const formData = {
            'id': this.editCartItemKey,
            'quantity': 1,
            properties: properties,
        }

        fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }).finally(() => {
            window.cart.getCart();
            this.classList.remove("loading");
        });
    };

    buildQueryProducts = (ids) => {
        if (!ids || !ids.length) {
            return null;
        }

        const queryStr = ids.map((id) => `(id:${id})`).join(" OR ");

        const query = `
            query productsById {
                products(first: 50, query: "${queryStr}") {
                    nodes {
                        id
                        title
                        totalInventory
                        featuredImage {
                            src
                        }
                        handle
                        metafields(
                            identifiers: [
                                {namespace: "custom", key: "linked_swatch"},
                                {namespace: "custom", key:"linked_badge"},
                                {namespace: "custom", key: "linked_swatch_title"},
                                {namespace: "custom", key: "infinite_dropdown_variant_title"} ]
                        ) {
                            value
                            key
                        }
                    }
                }
            }
        `;

        return query;
    };

    executeGraphQlQuery = async ({ query, variables }) => {
        if (!CHROMA.apis.storefront.accessToken) {
            console.error("----- Storefront access token is missing -----");

            return null;
        }

        const url = CHROMA.apis.storefront.endpoint;

        // remove line breaks and double space for legibility
        const cleanQuery = query.replace(/\n/g, " ").replace(/ {2}/g, "");

        const config = {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Shopify-Storefront-Access-Token":
                    CHROMA.apis.storefront.accessToken,
            },
            body: JSON.stringify({
                query: cleanQuery,
                // only add variables if they actually exist
                ...(variables ? { variables } : {}),
            }),
        };

        return fetch(url, config);
    };
}

customElements.define("form-multi-bundles", FormMultiBundles);
